import { format, parseISO } from 'date-fns';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DisplayButton } from '@xo-union/tk-ui-links';
import Icon from '@xo-union/tk-component-icons';

import { WeddingWebsiteQuery } from '../../generated/graphql';
import { basicInfoRailRoute } from '../../helpers/routes';
import styles from './basicInfo.scss';
import BasicInfoText from './BasicInfoText';

interface Props {
  data?: WeddingWebsiteQuery;
  weddingDateText: string;
  rightRail?: boolean;
  as?: string; // What to render the H4 component holding the "name" as, if you want it to be something other than "h4".
  showExperiment?: boolean;
  isPreview?: boolean;
}

export const formatDate = (date: string) => (date ? format(parseISO(date), 'MMMM d, yyyy') : '');

const BasicInfoItem: React.FC<Props> = ({
  data,
  weddingDateText,
  rightRail,
  showExperiment = false,
  isPreview = false,
}) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const hideDisplayButton = Boolean(showExperiment && isPreview);

  const openBasicInfoEdit = () => {
    history.push(basicInfoRailRoute(pathname.includes('preview')));
  };

  const containerStyle = rightRail ? styles.railContainer : styles.basicInfoContainer;
  return (
    <div className={containerStyle}>
      <div className={showExperiment ? styles.coupleNames : styles.name}>
        {data?.member?.firstName} &amp; {data?.member?.fianceFirstName}
      </div>
      <>
        {hideDisplayButton ? null : (
          <DisplayButton
            className={styles.button}
            type="button"
            tabIndex={0}
            onClick={openBasicInfoEdit}
            data-testid="basic-info-edit"
          >
            <Icon name="edit" size="sm" className={styles.event__head__edit__icon} />
          </DisplayButton>
        )}
      </>
      <BasicInfoText data={data} weddingDateText={weddingDateText} showExperiment={showExperiment} />
    </div>
  );
};

export default BasicInfoItem;
